/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useSelector } from 'react-redux'
import WizardFooter from './WizardFooter'
import InitialApplicationChatAssistant from '../AI/AIChatAssistant/InitialApplicationChatAssistant'
import Button from '../Shared/Button'

type WizardFormAssistantPageProps = {
  onSubmit: (data: { independent: true }) => void
}

const WizardFormAssistantPage = (
  props: WizardFormAssistantPageProps
): JSX.Element => {
  const { onSubmit } = props
  const state = useSelector((store: { createApplicationAssistant: { messages: unknown[] } }) => store.createApplicationAssistant)
  const proceedToPlatform = () => {
    onSubmit({
      independent: true,
    })
  }

  return (
    <>
      <div id="new-assistant-form" className="new-app-form">
        <div className="new-app-goal-settings">
          <InitialApplicationChatAssistant />
        </div>
      </div>
      {state.messages.length <= 2 && (
        <WizardFooter>
          <div className="link-classic-builder-container">
            <Button text type="type" onClick={proceedToPlatform}>
              I want to use the classic Builder
            </Button>
          </div>
        </WizardFooter>
      )}
    </>
  )
}

export default WizardFormAssistantPage
